import React from 'react';
import styles from './access.module.css';
import { fontSize, palette } from '../..';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const ManageAccessHeader = () => {
  const navigate = useNavigate();

  const handleBackButton = () => {
    navigate(-1);
  };

  return (
    <div className={styles.headerContainer}>
      <button
        className={styles.backLink}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: '0',
          fontSize: fontSize.medium,
          color: palette.primary.contrastText,
          gap: '0.5rem',
          fontWeight: '400',
        }}
        onClick={handleBackButton}
      >
        <ArrowBackIcon />
        Back
      </button>
      <div className={styles.header}>
        <h3
          style={{
            fontSize: fontSize.large,
            color: palette.primary.contrastText,
            marginRight: '7rem',
          }}
        >
          Manage Access
        </h3>
      </div>
    </div>
  );
};

export default ManageAccessHeader;
